import React, { FC, useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Row,
  Col
} from "antd";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { popupCenter } from "utils/appUtil";
import { useDispatch } from "react-redux";
import { ENCRYPT_TOKEN } from "reducers/authReducer";

const ProjectListModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { projects } = useSelector(
    (state: RootState) => state.dashboard
  );
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };


  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => { }}
        onCancel={handleCancel}
        width="480px"
        className="beam-modal scrollable"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <Row className="d-flex mt-1 mb-4">
          <Col>
            <h3>Project</h3>
          </Col>
        </Row>
        <Row className="scrollable-body mt-4" ref={scrollRef}>
          <Col span={24}>
            <React.Fragment>
              {projects &&
                projects?.projects.map(
                  (project, index) => {
                    return (
                      <Row className="person-item" key={index}>
                        <Col span={14}>
                          <h5>{project.name}</h5>
                        </Col>
                        <Col span={10} className="t-right">
                          <Button
                            className="beam-btn green-btn"
                            onClick={() => {
                              // popupCenter(
                              //   `${process.env.REACT_APP_SHARED_URI
                              //   }/cpc?userId=${localStorage.getItem(
                              //     "RID"
                              //   )}&connectionId=${localStorage.getItem("CID")}&projectId=${project.id}`,
                              //   "First CAD",
                              //   window.innerWidth * 0.7,
                              //   window.innerHeight * 0.9
                              // );
                              dispatch(
                                ENCRYPT_TOKEN({
                                  data: {
                                    payload: JSON.stringify({
                                      userId: localStorage.getItem("RID"),
                                      connectionId: `${localStorage.getItem("CID")}`,
                                      projectId: project.id,
                                      cudbServiceId: projects?.userServiceId,
                                    }),
                                  },
                                  callback: (token) => {
                                    window.open(`${process.env.REACT_APP_SHARED_URI}/cpc?token=${token.encryptedPayload}`, '_blank');
                                  },
                                })
                              );

                            }}
                          >
                            Create event
                          </Button>
                        </Col>
                      </Row>
                    )
                  }
                )}
            </React.Fragment>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default ProjectListModal;
